import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {select, Store} from '@ngrx/store';

import {Observable} from 'rxjs';


import {Authentication} from '@appModels/core-auth/auth/auth';

import * as fromReducer from '@appStore/reducers';
import * as fromSelectors from '@appStore/selectors';
import {Login} from '@appStore/actions/core-auth/auth/auth.actions';
import {UserService} from '@appServices/core-auth/user/user.service';
import {Router} from '@angular/router';
import * as moment from 'moment';


@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

    // The risky observable object might be used to show some msg in template
    risky$ = this.store.pipe(select(fromSelectors.isRisky));
    errMsg = null;

    auth$: Observable<Authentication>;
  loading = false;
  currentYear: number;

    constructor(
      private store: Store<fromReducer.auth.State>,
      private renderer: Renderer2,
      private userService: UserService,
      private router: Router
      ) {}

    ngOnDestroy() {
      this.renderer.removeClass(document.body, 'reset_screen');
    }
    ngOnInit() {
      this.currentYear = moment().year()
      this.renderer.addClass(document.body, 'reset_screen');
    }

    // The form is submitted with the corresponding model type `Authentication`
    onSubmit(code, password, confirmPassword) {
      this.loading = true;
      this.errMsg  = null;
      if(password !== confirmPassword) {
        this.errMsg = 'Passwords do not match';

        return;
      }
     this.userService.confirmPassword({
      resetCode: code,
      newPassword: password,
      confirmPassword: confirmPassword
     }).subscribe(data => {
        this.router.navigateByUrl(`/login`);
       this.loading = false;
     }, error => {
       this.errMsg = error
       this.loading = false;
     })

    }
}
